import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification, Drawer, Button, Space } from "antd";
import { faFilter, faEye, faTrash, faDownload, faInfoCircle, faCheckCircle, faCloudDownload, faCheck, faCloudUpload } from '@fortawesome/free-solid-svg-icons';
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";
// import VendorListDeletePopUp from "./DeletePopUp";
import { Link, useNavigate } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  voucherList as list,
  deleteVoucher,
  verifyVoucher
} from "../../../controllers/V1/winnersControllers";
import { getPage } from "../../../controllers/common";
import {usePermissions} from "../../../controllers/PermissionContext";
// import { FaPlusSquare } from "react-icons/fa";
import ConfirmPopup from "../../../components/ConfirmPopup";
import ExportPopup from  "./Export";
import { statusMessage } from "../../../controllers/common";
import { pdf } from '@react-pdf/renderer';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { processFormDataImages } from './PreviewPDF';
import PdfTemplates from '../../../components/PdfTemplates';
import AssignWinningVoucherPopup from "./AssignWinningVoucherPopup";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("winnerVoucher");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () =>  setFilterShow(!isFilterShow); 

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [isAssignWinningVoucherShow, setIsAssignWinningVoucherShow] = useState(false);
  const handleAssignWinningVoucherPopup = () => {
    setIsAssignWinningVoucherShow(!isAssignWinningVoucherShow);
    if(!isAssignWinningVoucherShow === false){
      getList();
    }
  }

  const [isBulkDownloadShow, setBulkDownloadShow] = useState(false);
  const handleBulkDownloadDrawer = () => setBulkDownloadShow(!isBulkDownloadShow);
  const [isBulkDownloading, setIsBulkDownloading] = useState(false);
  const [bulkDownloadProgress, setBulkDownloadProgress] = useState({ current: 0, total: 0 });

  const [deleteID, setDeleteID] = useState('');
  const [verifyID, setVerifyID] = useState('');
  
  const [helpText, setHelpText] = useState('');
  const handleSearchByChange = (e) => {
    try {
      const {value} = e.target;
      if(value === 'date' || value === 'purchase_date' || value === "draw_date"){
        setHelpText('Format should be YYYY-MM-DD. (e:g 2024-12-25)');
      } else{
        setHelpText('');
      }
    } catch (error) {
      
    }
  }

  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const selectAllCheckboxRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: "",
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");
  const [selectedVouchers, setSelectedVouchers] = useState([]);

  /*********************************************************
   *  Handle checkbox selection for vouchers
   *********************************************************/
  const handleCheckboxChange = (voucherNo, checked) => {
    if (checked) {
      setSelectedVouchers((prev) => [...prev, voucherNo]);
    } else {
      setSelectedVouchers((prev) => prev.filter((no) => no !== voucherNo));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const allVoucherNos = ALLLISTDATA.map((item) => item?.voucher_no).filter(Boolean);
      setSelectedVouchers(allVoucherNos);
    } else {
      setSelectedVouchers([]);
    }
  };

  const isAllSelected = ALLLISTDATA.length > 0 && ALLLISTDATA.every((item) => selectedVouchers.includes(item?.voucher_no));
  const isIndeterminate = selectedVouchers.length > 0 && selectedVouchers.length < ALLLISTDATA.length;

  // Set indeterminate state for select-all checkbox
  useEffect(() => {
    if (selectAllCheckboxRef.current) {
      selectAllCheckboxRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);

      const options = {
        type: "",
        condition: {
          ...(filter.filter_by === 'voucher_no'?{ voucher_no : filter?.search }:null),
          ...(filter.filter_by === 'prepared_by'?{ prepared_by : filter?.search }:null),
          ...(filter.filter_by === 'payment_to'?{ payment_to : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter.filter_by === 'ticket_id'?{ order_id : filter?.search }:null),
          ...(filter.filter_by === 'seller_name'?{ seller_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter.filter_by === 'total_amount'?{ total_amount : parseFloat(filter?.search) }:null),
          ...(filter.filter_by === 'date'?{ date : filter?.search }:null),
          ...(filter.filter_by === 'purchase_date'?{ purchase_date : filter?.search }:null),
          ...(filter.filter_by === 'draw_date'?{ draw_date : filter?.search }:null),
          
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT));
          setTotalCount(listData?.count||0);
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is for handle limit change
   *********************************************************/
  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    setCurrentPage(1);
    setSkip(0);
  };
 

  /*********************************************************
   *  This function is use to handle remove invoice
   *********************************************************/
  const handleRemove = async (id='') => {
    try {
      if(!id){
        notification.open({
          message: "Oops!",
          description: `Invoice id is required.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 2,
        });
      }else{
        const res = await deleteVoucher({id});
        if (res.status === true) {
          notification.open({
            message: "Success",
            description: `Data deleted successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle}/>,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
            duration: 2,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Operation not perform yet! please try in some time.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
        duration: 2,
      });
    }
    getList();
  };


  const handlePDFDownload = async (item) => {
    try {  
      navigate('/winners/voucher-pdf', {state : item})
    } catch (error) { 
      console.log('error', error)
    }
  }

  /*********************************************************
   *  Bulk PDF Download Function
   *********************************************************/
  const handleBulkPDFDownload = async (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      const fromDate = moment(form.get('from_date')).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const toDate = moment(form.get('to_date')).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      const payoutStatus = form.get('payout_status');

      if (!fromDate || !toDate) {
        notification.open({
          message: "Oops!",
          description: "Please select both From Date and To Date.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 2,
        });
        return;
      }

      if (moment(toDate).isBefore(moment(fromDate))) {
        notification.open({
          message: "Oops!",
          description: "To Date must be greater than or equal to From Date.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 2,
        });
        return;
      }

      setIsBulkDownloading(true);
      setBulkDownloadProgress({ current: 0, total: 0 });

      // Fetch vouchers between dates
      const options = {
        type: "",
        condition: {
          createdAt: {
            $gte: fromDate,
            $lte: toDate
          },
          ...(payoutStatus === "Pending" && { 
            $or: [
              { payout_status: { $exists: false } },
              { payout_status: "" },
              { payout_status: "Pending" }
            ]
          }),
          ...(payoutStatus === "Completed" && { payout_status: "Completed" }),
          status: 'A' // Only active vouchers
        },
        select: {},
        sort: { _id: -1 },
        skip: 0,
        limit: 10000, // Large limit to get all vouchers
      };

      const listData = await list(options);
      
      if (listData.status !== true || !listData.result || listData.result.length === 0) {
        notification.open({
          message: "Info",
          description: "No vouchers found for the selected date range.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "blue" }} icon={faInfoCircle}/>,
          duration: 2,
        });
        setIsBulkDownloading(false);
        return;
      }

      const vouchers = listData.result;
      setBulkDownloadProgress({ current: 0, total: vouchers.length });

      // Create zip file
      const zip = new JSZip();
      const folder = zip.folder(`Winning_Vouchers_${moment(fromDate).format('DD-MM-YYYY')}_to_${moment(toDate).format('DD-MM-YYYY')}`);

      // Process each voucher
      for (let i = 0; i < vouchers.length; i++) {
        const voucher = vouchers[i];
        try {
          // Process images for the voucher
          const processedData = await processFormDataImages(voucher);
          
          // Generate PDF using React.createElement
          const doc = React.createElement(PdfTemplates, { voucherData: processedData });
          const asPdf = pdf(doc);
          const blob = await asPdf.toBlob();
          
          // Convert blob to array buffer for zip
          const arrayBuffer = await blob.arrayBuffer();
          
          // Add to zip with voucher number as filename
          const fileName = `Voucher_${voucher?.order_id || `V${i + 1}`}_${moment(voucher?.date || new Date()).format('DD-MM-YYYY')}.pdf`;
          folder.file(fileName, arrayBuffer);
          
          setBulkDownloadProgress({ current: i + 1, total: vouchers.length });
        } catch (error) {
          console.error(`Error processing voucher ${voucher?.voucher_no}:`, error);
          // Continue with next voucher even if one fails
        }
      }

      // Generate zip file
      const zipBlob = await zip.generateAsync({ type: 'blob' });
      
      // Download zip file
      const zipFileName = `Winning_Vouchers_${moment(fromDate).format('DD-MM-YYYY')}_to_${moment(toDate).format('DD-MM-YYYY')}.zip`;
      saveAs(zipBlob, zipFileName);

      notification.open({
        message: "Success",
        description: `Successfully downloaded ${vouchers.length} voucher PDFs.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle}/>,
        duration: 3,
      });

      handleBulkDownloadDrawer();
    } catch (error) {
      console.error('Bulk download error:', error);
      notification.open({
        message: "Oops!",
        description: "Failed to download PDFs. Please try again.",
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
        duration: 2,
      });
    } finally {
      setIsBulkDownloading(false);
      setBulkDownloadProgress({ current: 0, total: 0 });
    }
  };

  const handleVerifyVoucher = async (id) => {
    try {
      const res = await verifyVoucher({id});
      if (res.status === true) {
        notification.open({
          message: "Success",
          description: `Data verified successfully.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle}/>,
          duration: 2,
        });
      } else {
        notification.open({
          message: "Oops!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 2,
        }); 
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      getList();
    }
  }
  
  const dropdownMenu = (items) => {
    return (
      <>
        <Menu>
          {(PERMISSION?.remove === 'Y' || PERMISSION?.fullAccess === 'Y') && (
            <Menu.Item key="01"onClick={()=>handlePDFDownload(items)}>
              <FontAwesomeIcon icon={faEye} />
                <span className="show_span_edit">PDF</span>
            </Menu.Item>
          )}

          {(PERMISSION?.remove === 'Y' || PERMISSION?.fullAccess === 'Y') && items?.status !== "D" && (
            <Menu.Item key={`02`} onClick={() => { setDeleteID(items._id); }} >
            <FontAwesomeIcon icon={faTrash} /> <span className="show_span">Remove</span>
            </Menu.Item>
          )}

          {/* {(PERMISSION?.verify === 'Y' || PERMISSION?.fullAccess === 'Y') && items?.isVerified === false && (
            <Menu.Item key={`03`} onClick={() => { setVerifyID(items._id); }} >
            <FontAwesomeIcon icon={faCheck} /> <span className="show_span">Verify</span>
            </Menu.Item>
          )}  */}
        </Menu>
      </>
    );
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    // Clear selections when filters or page changes
    setSelectedVouchers([]);
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "U-Winn CRM || Winners List";
  }, [currentPage, showRequest, filter, LIMIT]);

 

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Voucher List"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("")}
                    />
                    <Tab
                      label="Active"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("A")}
                    />
                    <Tab
                      label="Delete"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("D")}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                  <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filters
                    </Link>
                  </div>
                    <div className="inventory_filter_div" onClick={handleExportDrawer}>
                    <FontAwesomeIcon icon={faCloudDownload} />
                      <Link
                        to={false}
                        className="filter_btn_invontry_rating_review"
                      >
                        Export
                      </Link>
                    </div>
      
                  {(PERMISSION?.assign === 'Y' || PERMISSION?.fullAccess === 'Y') && (  
                    <div className="inventory_filter_div" onClick={handleAssignWinningVoucherPopup}>
                      <FontAwesomeIcon icon={faCloudUpload} />
                      <span className="show_span">Assing Voucher</span>
                    </div>
                  )}

                  <div className="inventory_filter_div" onClick={handleBulkDownloadDrawer}>
                  <FontAwesomeIcon icon={faDownload} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Bulk Download PDF
                    </Link>
                  </div>

                  <div className="inventory_filter_div" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <label htmlFor="rowsPerPage" style={{ margin: 0, fontSize: "14px", whiteSpace: "nowrap" }}>
                      Rows:
                    </label>
                    <select
                      id="rowsPerPage"
                      value={LIMIT}
                      onChange={handleLimitChange}
                      className="form-control"
                      style={{
                        minWidth: "80px",
                        padding: "4px 8px",
                        fontSize: "14px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        cursor: "pointer"
                      }}
                    >
                      <option value={2}>2</option>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  
                  {(PERMISSION?.add === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                    <div onClick={()=> navigate('/winners/generate-voucher')}>
                      <button type="button" class="btn btn-dark">
                        <FontAwesomeIcon icon="fa-light fa-plus Promotions_faPlus_Squares" />
                        <span className="request_new_categories">Add New</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  ref={selectAllCheckboxRef}
                                  checked={isAllSelected}
                                  onChange={(e) => handleSelectAll(e.target.checked)}
                                  style={{ cursor: "pointer" }}
                                />
                              </th>
                              <th>Sl. No.</th>
                              <th>Voucher No.</th>
                              <td>Ticket ID</td>
                              <th>Payment To</th>
                              <th>Seller name</th>
                              <th>Winning Amount</th>
                              <th>Prepared By</th>
                              <th>Checked By</th>
                              <th>Purchase Date</th>
                              <th>Draw Date</th>
                              <th>Created At</th>
                              <th>Status</th>
                              <th>Assigned To</th>
                              <th>Payout Status</th>
                              <th>Payout Date & Time</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr 
                                    key={index}
                                    onClick={() => {
                                      const isSelected = selectedVouchers.includes(items?.voucher_no);
                                      handleCheckboxChange(items?.voucher_no, !isSelected);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <td onClick={(e) => e.stopPropagation()}>
                                      <input
                                        type="checkbox"
                                        checked={selectedVouchers.includes(items?.voucher_no)}
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          handleCheckboxChange(items?.voucher_no, e.target.checked);
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </td>
                                    <td>
                                      {index + 1 + SKIP}
                                    </td>
                                    <td>{items?.voucher_no}</td>
                                    <td className="admin_user_list_date">{items?.order_id}</td>
                                    <td className="admin_user_list_date">{items?.payment_to}</td>
                                    <td className="admin_user_list_date">{items?.seller_name}</td>
                                    <td className="admin_user_list_date">{parseFloat(items?.total_amount)?.toFixed(2)}</td>
                                    <td className="admin_user_list_date">{items?.prepared_by}</td>
                                    <td className="admin_user_list_date">{items?.checked_by || "--"}</td>
                                      
                                    <td className="admin_user_list_date">{moment(`${items?.purchase_date}`).format("DD-MM-YYYY")}</td>
                                    <td className="admin_user_list_date">{items?.draw_date ? moment(`${items?.draw_date}`).format("DD-MM-YYYY"):"-"}</td>
                                    <td className="admin_user_list_date">{moment(`${items?.createdAt}`).format("DD-MM-YYYY HH:mm")}</td>
                                    <td className="admin_user_list_date" dangerouslySetInnerHTML={{__html: statusMessage(items.status)}}></td>
                                    {items?.assigned_to ? (
                                      <td className="admin_user_list_date">
                                        {items?.assigned_to?.admin_first_name} <br/>
                                        {items?.assigned_to?.account_id}
                                      </td>
                                    ) : (
                                      <td className="admin_user_list_date"> -- </td>
                                    )}
                                    <td className="admin_user_list_date" dangerouslySetInnerHTML={{__html: statusMessage(items.payout_status)}}></td>
                                    <td className="admin_user_list_date">
                                      {items?.payout_date ? moment(items?.payout_date).format("YYYY-MM-DD HH:mm") : "--"}
                                    </td>
                                    <td onClick={(e) => e.stopPropagation()}>
                                      {items?.status === 'A'?(
                                        <Dropdown
                                          overlay={() => dropdownMenu(items)}
                                          placement="bottomLeft"
                                          arrow
                                        >
                                            <FontAwesomeIcon icon={faEllipsis} />
                                        </Dropdown>
                                      ):('--')}
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={10} /> : <tr> 
                                <td colspan="16" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <p>{`Showing ${SKIP + 1} - ${LIMIT * currentPage} of ${totalCount} items`}</p>
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="filter_by" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" onChange={handleSearchByChange} id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='ticket_id' selected={filter?.filter_by ==='ticket_id'?true:false}>Ticket ID</option>
                  <option value='voucher_no' selected={filter?.filter_by ==='voucher_no'?true:false}>Voucher No</option>
                  <option value='payment_to' selected={filter?.filter_by ==='payment_to'?true:false}>Payment To</option>
                  <option value='seller_name' selected={filter?.filter_by ==='seller_name'?true:false}>Seller Name</option>
                  <option value='total_amount' selected={filter?.filter_by ==='total_amount'?true:false}>Winning Amount</option>
                  <option value='prepared_by' selected={filter?.filter_by ==='prepared_by'?true:false}>Prepared By</option>
                  <option value='date' selected={filter?.filter_by ==='date'?true:false}>Date</option>
                  <option value='purchase_date' selected={filter?.filter_by ==='purchase_date'?true:false}>Purchase Date</option>
                  <option value='draw_date' selected={filter?.filter_by ==='draw_date'?true:false}>Draw Date</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="search" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
                {helpText?<label style={{color:'blue'}}>{helpText}</label>:''}
              </div>
              {/* <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="from_date"
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="to_date"
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div> */}
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
      {/* Bulk Download PDF Drawer */}
      <Drawer
        title="Bulk Download PDFs"
        placement={`right`}
        width={500}
        onClose={handleBulkDownloadDrawer}
        open={isBulkDownloadShow}
        extra={
          <Space>
            <Button onClick={handleBulkDownloadDrawer}>Cancel</Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='bulk_download_form' onSubmit={handleBulkPDFDownload}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="from_date" className="all_section_for_label_main_class" >
                  From Date :
                </label>
                <input
                  title="Select from date"
                  type="date"
                  name="from_date"
                  className="form-control store_input_field"
                  id="from_date"
                  required
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="to_date" className="all_section_for_label_main_class" >
                  To Date :
                </label>
                <input
                  title="Select to date"
                  type="date"
                  name="to_date"
                  className="form-control store_input_field"
                  id="to_date"
                  required
                />
              </div>

              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="to_date" className="all_section_for_label_main_class" >
                  Payout Status :
                </label>
                <select name="payout_status" className="form-control store_input_field" id="payout_status" placeholder="Enter payout status">
                  <option value="">Select payout status</option>
                  <option value="Pending">Pending</option>
                  <option value="Completed">Completed</option>
                </select>
              </div>
              {isBulkDownloading && (
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <p style={{ marginBottom: '5px' }}>
                      Processing: {bulkDownloadProgress.current} / {bulkDownloadProgress.total}
                    </p>
                    <div style={{ 
                      width: '100%', 
                      backgroundColor: '#f0f0f0', 
                      borderRadius: '4px',
                      overflow: 'hidden'
                    }}>
                      <div style={{
                        width: `${(bulkDownloadProgress.current / bulkDownloadProgress.total) * 100}%`,
                        backgroundColor: '#1890ff',
                        height: '20px',
                        transition: 'width 0.3s ease'
                      }}></div>
                    </div>
                  </div>
                </div>
              )}
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Download PDFs"
                  type="submit"
                  className="form-control btn btn-black"
                  style={{ backgroundColor: "black", color: "white" }}
                  disabled={isBulkDownloading}
                >
                  {isBulkDownloading ? 'Downloading...' : 'Download PDFs'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>

      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer}  />
      <ConfirmPopup popUpOpen={deleteID?true:false} togglePopUp={()=>setDeleteID('')} process={()=>handleRemove(deleteID)} />
      <ConfirmPopup popUpOpen={verifyID?true:false} togglePopUp={()=>setVerifyID('')} process={()=>handleVerifyVoucher(verifyID)} />
      <AssignWinningVoucherPopup popUpOpen={isAssignWinningVoucherShow?true:false} togglePopUp={handleAssignWinningVoucherPopup} voucher_no={selectedVouchers || []} />
    </>
  );
}
